import React from 'react'

export default function footer() {
  return (
    <div className='footer'>
        <span>ThankYou For Visiting!</span>
        <a href='#top' className='backtotop-btn'  data-aos="flip-out" data-aos-offset="0">Back to Top</a>
    </div>
  )
}
